import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";

const imageStyles = {
  width: "180px",
  height: "200px",
  marginLeft: "20px",
};

const imageStyles1 = {
  height: "227px",
  marginLeft: "20px",
};

const boxStyles1 = {
  boxShadow: "0px 7px 16px 0px rgba(172 ,153 ,153, 0.5)",
  padding: "7px 25px 9px 22px",
  backgroundColor: "#fff",
  height: "415px",
};

const Members = () => {
  const [activeTab1, setActiveTab1] = useState("Visitor");
  const [activeTab2, setActiveTab2] = useState("Auxiliary Visitor");

  const handleTabSelect1 = (selectedTab) => {
    setActiveTab1(selectedTab);
  };

  const handleTabSelect2 = (selectedTab) => {
    setActiveTab2(selectedTab);
  };

  return (
    <div
      className="container-fluid py-3"
      style={{ backgroundColor: "#172440" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-12">
            <div
              style={boxStyles1}
              id="style-1"
              className="bootstrap-scrollbar"
            >
              <Tab.Container activeKey={activeTab1} onSelect={handleTabSelect1}>
                <div className="section-heading">
                  <h2 className="entry-title">
                    Lasallian South Asian District (Sri Lanka & India)
                  </h2>
                </div>
                <br />
                <div className="entry-content">
                  <div className="row">
                    <div className="col-md-7 col-lg-6">
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Visitor"
                            className={`nav-link mb-3 p-3 shadow ${activeTab1 === "Visitor" ? "active" : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            Visitor
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="District Council"
                            className={`nav-link mb-3 p-3 shadow ${activeTab1 === "District Council" ? "active" : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            District Council
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Sector Leadership (India)"
                            className={`nav-link mb-3 p-3 shadow ${activeTab2 === "Sector Leadership (India)"
                              ? "active"
                              : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            Sector Leadership (India)
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Sector Leadership (Sri Lanka)"
                            className={`nav-link mb-3 p-3 shadow ${activeTab2 === "Sector Leadership (Sri Lanka)"
                              ? "active"
                              : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            Sector Leadership
                            <p>(Sri Lanka)</p>
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                    <div className="col-md-5 col-lg-6">
                      <div className="tab-image">
                        {activeTab1 === "Visitor" ? (
                          <img
                            src={
                              activeTab1 === "Visitor"
                                ? "images/priestimage/Christy-cross.jpg"
                                : ""
                            }
                            alt={activeTab1}
                            style={imageStyles}
                          />
                        ) : null}
                        <p
                          style={{
                            textAlign: "center",
                            marginTop: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <br />
                          <span style={{ fontSize: "12px", color: "black" }}>
                            {activeTab1 === "Visitor" ? (
                              "REV. BRO. CHRISTY CROSS, FSC"
                            ) : (
                              <ul>
                                <li>Br. Christy Croos, FSC – Visitor</li>
                                <li>Br. R. Victor, FSC</li>
                                <li>Bro. Henry Dissanayake, FSC</li>
                                <li>Br. John Fernando, FSC</li>
                                <li>Br. Yoganathan Soysa, FSC</li>
                                <li>Br. Inego Amalan, FSC</li>
                                <li>Br. Tharshan Peries, FSC</li>
                              </ul>
                            )}
                          </span>
                          <br />
                          <span style={{ fontSize: "15px", color: "red" }}>
                            {activeTab1}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
          {/* 2nd tab */}
          <div className="col-md-6 col-12">
            <div
              style={boxStyles1}
              id="style-1"
              className="bootstrap-scrollbar"
            >
              <Tab.Container activeKey={activeTab2} onSelect={handleTabSelect2}>
                <div className="section-heading">
                  <h2 className="entry-title">Sector Team</h2>
                </div>
                <br />
                <div className="entry-content">
                  <div className="row">
                    <div className="col-md-7 col-lg-6">
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Auxiliary Visitor"
                            className={`nav-link mb-3 p-3 shadow ${activeTab2 === "Auxiliary Visitor" ? "active" : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            Auxiliary Visitor
                          </Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item>
                          <Nav.Link
                            eventKey="Sector Leadership (India)"
                            className={`nav-link mb-3 p-3 shadow ${activeTab2 === "Sector Leadership (India)"
                                ? "active"
                                : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            Sector Leadership (India)
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Sector Leadership (Sri Lanka)"
                            className={`nav-link mb-3 p-3 shadow ${activeTab2 === "Sector Leadership (Sri Lanka)"
                                ? "active"
                                : ""
                              }`}
                            style={{
                              fontFamily: "Arial, sans-serif",
                              fontSize: "15px",
                              fontWeight: "bold",
                              transition: "color 0.3s ease",
                            }}
                          >
                            Sector Leadership (Sri Lanka)
                          </Nav.Link>
                        </Nav.Item> */}
                      </Nav>
                    </div>
                    <div className="col-md-5 col-lg-6">
                      <div className="tab-image">
                        {activeTab2 === "Auxiliary Visitor" ? (
                          <img
                            src="images/priestimage/Fr.Victor.jpg"
                            alt={activeTab2}
                            style={imageStyles1}
                          />
                        ) : null}
                        <p
                          style={{
                            textAlign: "center",
                            marginTop: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <br />
                          <span style={{ fontSize: "12px", color: "black" }}>
                            {activeTab2 === "Auxiliary Visitor" ? (
                              "REV.BRO.R VICTOR, FSC"
                            ) : activeTab2 ===
                              "Sector Leadership (Sri Lanka)" ? (
                              <ul style={{ listStyleType: "none" }}>
                                <li>Bro. Christy Croos,FSC – Visitor</li>
                                <li>Bro. Denzil Perera,FSC</li>
                                <li>Bro. Henry Dissanayake,FSC</li>
                                <li>Bro. Yoganathan Soysa,FSC</li>
                                <li>Bro. Janaka Fonseka,FSC</li>
                                <li>Bro. Tharshan Peries,FSC</li>
                                <li>Bro. Bob Vang Livera,FSC</li>
                              </ul>
                            ) : (
                              <ul style={{ listStyleType: "none" }}>
                                <li>Bro. R.Victor,FSC, Auxiliary Visitor</li>
                                <li>Bro. John Fernando,FSC</li>
                                <li>Bro. Inego Amalan,FSC</li><br></br>
                                <li>Bro. Jeyakumar,FSC</li>
                                <li>Bro. Arockia Vincent,FSC</li>
                                <li>Bro. Mark Tony,FSC</li>

                              </ul>
                            )}
                          </span>
                          <br />
                          <span style={{ fontSize: "15px", color: "red" }}>
                            {activeTab2}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Members;
